/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Feature_Full_SwingInputs */

const en_home_feature_full_swing = /** @type {(inputs: Home_Feature_Full_SwingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full-swing and short-game instruction`)
};

const es_home_feature_full_swing = /** @type {(inputs: Home_Feature_Full_SwingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instrucción de swing completo y juego corto`)
};

const de_home_feature_full_swing = /** @type {(inputs: Home_Feature_Full_SwingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unterricht für Fullswing und kurzes Spiel`)
};

const zh_home_feature_full_swing = /** @type {(inputs: Home_Feature_Full_SwingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全挥杆与短杆教学`)
};

const ar_home_feature_full_swing = /** @type {(inputs: Home_Feature_Full_SwingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تعليم السوينغ الكامل واللعبة القصيرة`)
};

const fr_home_feature_full_swing = /** @type {(inputs: Home_Feature_Full_SwingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enseignement du grand jeu et du petit jeu`)
};

const vi_home_feature_full_swing = /** @type {(inputs: Home_Feature_Full_SwingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dạy full-swing và lối chơi ngắn`)
};

const sw_home_feature_full_swing = /** @type {(inputs: Home_Feature_Full_SwingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mafunzo ya full-swing na short game`)
};

const th_home_feature_full_swing = /** @type {(inputs: Home_Feature_Full_SwingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สอนฟูลสวิงและเกมสั้น`)
};

const bs_home_feature_full_swing = /** @type {(inputs: Home_Feature_Full_SwingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instrukcija full-swinga i short gamea`)
};

const ja_home_feature_full_swing = /** @type {(inputs: Home_Feature_Full_SwingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フルスイングとショートゲームのレッスン`)
};

const ko_home_feature_full_swing = /** @type {(inputs: Home_Feature_Full_SwingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`풀스윙 및 숏게임 레슨`)
};

const pt_home_feature_full_swing = /** @type {(inputs: Home_Feature_Full_SwingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aulas de swing completo e jogo curto`)
};

const it_home_feature_full_swing = /** @type {(inputs: Home_Feature_Full_SwingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lezioni di swing completo e gioco corto`)
};

const sv_home_feature_full_swing = /** @type {(inputs: Home_Feature_Full_SwingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fullsving och short game-träning`)
};

const nl_home_feature_full_swing = /** @type {(inputs: Home_Feature_Full_SwingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les in volledige swing en kort spel`)
};

const da_home_feature_full_swing = /** @type {(inputs: Home_Feature_Full_SwingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Undervisning i fuldt sving og kortspil`)
};

const nb_home_feature_full_swing = /** @type {(inputs: Home_Feature_Full_SwingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fullsving og short game-instruksjon`)
};

const fi_home_feature_full_swing = /** @type {(inputs: Home_Feature_Full_SwingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Täyden svingin ja lähipelin opetus`)
};

const pl_home_feature_full_swing = /** @type {(inputs: Home_Feature_Full_SwingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nauka pełnego swingu i krótkiej gry`)
};

const ru_home_feature_full_swing = /** @type {(inputs: Home_Feature_Full_SwingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обучение полному свингу и короткой игре`)
};

const tr_home_feature_full_swing = /** @type {(inputs: Home_Feature_Full_SwingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full swing ve kısa oyun eğitimi`)
};

const hi_home_feature_full_swing = /** @type {(inputs: Home_Feature_Full_SwingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फुल स्विंग और शॉर्ट गेम का प्रशिक्षण`)
};

const id_home_feature_full_swing = /** @type {(inputs: Home_Feature_Full_SwingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelatihan ayunan penuh dan short game`)
};

const ms_home_feature_full_swing = /** @type {(inputs: Home_Feature_Full_SwingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bimbingan hayunan penuh dan permainan pendek`)
};

const cs_home_feature_full_swing = /** @type {(inputs: Home_Feature_Full_SwingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Výuka plného švihu a krátké hry`)
};

const el_home_feature_full_swing = /** @type {(inputs: Home_Feature_Full_SwingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Οδηγίες για πλήρες σβινγκ και short game`)
};

const he_home_feature_full_swing = /** @type {(inputs: Home_Feature_Full_SwingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שיעורי סווינג מלא ומשחק קצר`)
};

const af_home_feature_full_swing = /** @type {(inputs: Home_Feature_Full_SwingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volswing- en kortspelonderrig`)
};

const hu_home_feature_full_swing = /** @type {(inputs: Home_Feature_Full_SwingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teljes swing és rövid játék oktatása`)
};

/**
* | output |
* | --- |
* | "Full-swing and short-game instruction" |
*
* @param {Home_Feature_Full_SwingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const home_feature_full_swing = /** @type {((inputs?: Home_Feature_Full_SwingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Feature_Full_SwingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_feature_full_swing(inputs)
	if (locale === "de") return de_home_feature_full_swing(inputs)
	if (locale === "zh") return zh_home_feature_full_swing(inputs)
	if (locale === "ar") return ar_home_feature_full_swing(inputs)
	if (locale === "fr") return fr_home_feature_full_swing(inputs)
	if (locale === "vi") return vi_home_feature_full_swing(inputs)
	if (locale === "sw") return sw_home_feature_full_swing(inputs)
	if (locale === "th") return th_home_feature_full_swing(inputs)
	if (locale === "bs") return bs_home_feature_full_swing(inputs)
	if (locale === "ja") return ja_home_feature_full_swing(inputs)
	if (locale === "ko") return ko_home_feature_full_swing(inputs)
	if (locale === "pt") return pt_home_feature_full_swing(inputs)
	if (locale === "it") return it_home_feature_full_swing(inputs)
	if (locale === "sv") return sv_home_feature_full_swing(inputs)
	if (locale === "nl") return nl_home_feature_full_swing(inputs)
	if (locale === "da") return da_home_feature_full_swing(inputs)
	if (locale === "nb") return nb_home_feature_full_swing(inputs)
	if (locale === "fi") return fi_home_feature_full_swing(inputs)
	if (locale === "pl") return pl_home_feature_full_swing(inputs)
	if (locale === "ru") return ru_home_feature_full_swing(inputs)
	if (locale === "tr") return tr_home_feature_full_swing(inputs)
	if (locale === "hi") return hi_home_feature_full_swing(inputs)
	if (locale === "id") return id_home_feature_full_swing(inputs)
	if (locale === "ms") return ms_home_feature_full_swing(inputs)
	if (locale === "cs") return cs_home_feature_full_swing(inputs)
	if (locale === "el") return el_home_feature_full_swing(inputs)
	if (locale === "he") return he_home_feature_full_swing(inputs)
	if (locale === "af") return af_home_feature_full_swing(inputs)
	if (locale === "hu") return hu_home_feature_full_swing(inputs)
	return en_home_feature_full_swing(inputs)
});